import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FacadeTextureDirectionEnum } from '../../models/cutting/cutting-facade.model';
import { FacadeView } from '../../models/cutting/facade-view.model';

@Injectable()
export class FacadeSettingsStateService {
  userId = 0;

  private _panel: BehaviorSubject<FacadeView> = new BehaviorSubject<FacadeView>(
    new FacadeView({
      orientation: true,
      textureDirection: FacadeTextureDirectionEnum.AlongWidth,
      height: 0,
      width: 0,
      count: 1,
    })
  );

  get panel$(): Observable<FacadeView> {
    return this._panel.asObservable();
  }

  updatePanel(panel: FacadeView): void {
    this._panel.next(panel);
  }
}
